import { ShieldCheck, Wrench, Star } from "lucide-react";
import { Link } from "react-router-dom";

const benefits = [
  { icon: Star, label: "Priority Scheduling" },
  { icon: Wrench, label: "Seasonal Tune-Ups" },
  { icon: ShieldCheck, label: "Members Save 5%" },
];

export default function Membership() {
  return (
    <section className="py-12 md:py-16" data-testid="membership-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="rounded-3xl bg-ink-800 ring-1 ring-white/10 p-6 md:p-10 grid md:grid-cols-2 gap-6 items-center">
          <div>
            <div className="text-xs uppercase tracking-[0.22em] text-ice-400">Maintenance Plan</div>
            <h3 className="mt-3 font-display text-3xl md:text-4xl font-black">Keep your system running. Pay less for repairs.</h3>
            <p className="mt-3 text-silver-300 max-w-md">Sign up for the AIR-COLD Maintenance Plan and get priority service, seasonal tune-ups, and member-only pricing.</p>
            <Link to="/contact" className="mt-5 btn-primary rounded-full px-5 py-3 text-sm inline-flex" data-testid="member-join">Join the Plan</Link>
          </div>
          <ul className="grid gap-3">
            {benefits.map(({icon: Icon, label}, i) => (
              <li key={i} className="flex items-center gap-3 rounded-2xl bg-ink-700 ring-1 ring-white/10 px-4 py-3" data-testid={`member-${i}`}>
                <div className="size-10 rounded-xl bg-ice-400/15 ring-1 ring-ice-400/30 grid place-items-center"><Icon className="size-4 text-ice-400"/></div>
                <span className="text-sm font-semibold">{label}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
